import React from 'react';
import classNames from 'classnames';
import { ReactComponent as Icon } from '../polygon.svg';
import { PolygonDirection } from './enums/PolygonDirection';
import classes from './PolygonIcon.module.scss';

interface IProps extends React.SVGProps<SVGSVGElement> {
    direction: PolygonDirection;
}

export const PolygonIcon: React.FC<IProps> = ({ direction, ...props }) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Icon {...props} className={classNames(props.className, classes[direction])} />
);
